import React, { useEffect, useState } from "react";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Modal from "~/components-shared/Modal";
import toastsActionCreators from "~/store/toasts/actions";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import styled from "styled-components";
import { Alert } from "~/components-shared";
import api from "~/lib/api";
import { handleError } from "~/lib/helpers";
import { ShareIntegrationsForm } from "~/forms/ShareIntegrationsForm";
import shareIntegrationsSchema from "~/forms/ShareIntegrationsForm/ShareIntegrationsSchema";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const ShareIntegrationsModal = _ref => {
  let {
    filterIntegrations,
    onClose
  } = _ref;
  const {
    t
  } = useTranslation();
  const [error, setError] = useState(undefined);
  const [token, setToken] = useState("");
  const [loadingToken, setLoadingToken] = useState(false);
  const dispatch = useDispatch();
  const [loadingSend, setLoadingSend] = useState(false);
  const defaultValues = {
    integrations: [],
    email: ""
  };
  const {
    handleSubmit,
    control,
    reset,
    watch
  } = useForm({
    resolver: yupResolver(shareIntegrationsSchema),
    defaultValues
  });
  useEffect(() => {
    setLoadingToken(true);
    api.getIntegrationPublicToken().then(data => {
      setToken(data.token);
    }).catch(e => {
      setError(handleError(e));
    }).finally(() => {
      setLoadingToken(false);
    });
  }, []);
  const onSubmit = handleSubmit(data => {
    setLoadingSend(true);
    api.sendIntegrationsPublicToken(data).then(() => {
      dispatch(toastsActionCreators.pushed({
        severity: "success",
        message: t("ShareIntegrationsModal.emailSent", {
          email: data.email
        }),
        timeout: 10000
      }));
      reset(defaultValues);
      onClose();
    }).catch(e => {
      setError(handleError(e));
    }).finally(() => {
      setLoadingSend(false);
    });
  });
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("ShareIntegrationsModal.shareWithIT"),
    onClose: onClose,
    maxWidth: "500px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(ShareIntegrationsForm, {
    filterIntegrations: filterIntegrations,
    loadingToken: loadingToken,
    loadingSend: loadingSend,
    watch: watch,
    onSubmit: onSubmit,
    token: token,
    control: control
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "translucent",
    s: {
      px: 8
    },
    onClick: onClose,
    rounded: true
  }, t("common.actions.close")))));
};
export default ShareIntegrationsModal;